// Instance
import MainAPI from "@/app/apis/main/main-api.js";

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js";

const queryString = require("querystring")

class BreedersAPI extends MainAPI {
    /**
     * @return Object
     */
    
    // old way of registering breeders
    async registerBreeder(breederDetails) {
        const newFormData = new FormData();

        newFormData.append("formData", JSON.stringify(breederDetails.formDetails));

        newFormData.append("profileImage", breederDetails.breederImg);

        return API.post(`${ENDPOINTS.POST_REGISTER_BREEDER}`, newFormData, {
            header: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    // new way: create both user and breeder at the same time
    async registerUserAndBreeder(breederDetails) {
        const newFormData = new FormData();

        newFormData.append("formData", JSON.stringify(breederDetails.formDetails));
        newFormData.append("profileImage", breederDetails.profileImage);

        return API.post(`${ENDPOINTS.POST_REGISTER}`, newFormData, {
            header: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    async getBreederById(userId) {
        return API.get(`${ENDPOINTS.GET_BREEDERS}/${userId}`);
    }

    /**
     * Retrieves breeder details by user ID.
     *
     * @async
     * @function getBreederByUserId
     * @param {string} userId - The ID of the user whose breeder details are to be retrieved.
     * @returns {Promise<Object>} A promise that resolves to an object containing breeder details.
     * @throws {Error} If an error occurs while retrieving the breeder details.
     */
    async getBreederByUserId(userId) {
        return API.get(`${ENDPOINTS.GET_BREEDERS}/${userId}`);
    }

    async getBreederBioById(breederSysId) {
        return API.get(`${ENDPOINTS.GET_BREEDERS}/bio/${breederSysId}`);
    }

    async updateBreederDetails(details) {
        const newFormData = new FormData();

        newFormData.append("formData", JSON.stringify(details.requestDetails));
        newFormData.append("profileImage", details.breederImg);

        return API.put(`${ENDPOINTS.PUT_BREEDER}/details/update`, newFormData);
    }

    async addBreederBio(details) {
        return API.post(`${ENDPOINTS.PUT_BREEDER}/create-bio`, details);
    }

    async updateBreederBio(details) {
        return API.put(`${ENDPOINTS.PUT_BREEDER}/update-bio`, details);
    }

    async requestForReactivate(details) {
        return API.put(`${ENDPOINTS.PUT_BREEDER}/activate-deactivate`, details);
    }
}

export default new BreedersAPI();
